import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SilaCoreService } from '../services/sila-core.service';
import { SilaCoreComponent } from '../components/home/sila-core.component';
import { SilaCoreHeaderComponent } from '../components/header/sila-core-header.component';

import { ErrorMessageService } from '../services/utilities/error-message.service';
import { SBValidationService } from '../services/utilities/sbvalidation.service';
import { UtilityService } from '../services/utilities/utility.service';
import { SilaCoreConfigInterface, SilaCoreConfigMode, SilaCoreConfig } from './sila-core.config';


export function dataServiceFactory(configObject: SilaCoreConfigInterface ) {
    SilaCoreConfig.setConfig(configObject);
    return () => SilaCoreConfig;
}

@NgModule({
    declarations: [
        // Pipes.
        // Directives.
        // Components.
        SilaCoreComponent,
        SilaCoreHeaderComponent
    ],
    imports: [
        CommonModule,
        RouterModule
    ],
    exports: [
        // Pipes.
        // Directives.
        // Components.
        SilaCoreComponent,
        SilaCoreHeaderComponent
    ]
})
// Consider registering providers using a forRoot() method
// when the module exports components, directives or pipes that require sharing the same providers instances.
// Consider registering providers also using a forChild() method
// when they requires new providers instances or different providers in child modules.
export class SilaCoreModule {

    /**
     * Use in AppModule: new instance of SumService.
     */
    public static forRoot(config: SilaCoreConfigInterface): ModuleWithProviders {
        return {
            ngModule: SilaCoreModule,
            providers: [
                {
                    provide : SilaCoreConfig,
                    useFactory: dataServiceFactory(config),
                    multi: true
                },
                SilaCoreService, ErrorMessageService, SBValidationService, UtilityService
            ]
        };
    }

    /**
     * Use in features modules with lazy loading: new instance of SumService.
     */
    public static forChild(config: SilaCoreConfigInterface): ModuleWithProviders {
        return {
            ngModule: SilaCoreModule,
            providers: [
                {
                    provide : SilaCoreConfig,
                    useFactory: dataServiceFactory(config),
                    multi: true
                },
                SilaCoreService, ErrorMessageService, SBValidationService, UtilityService
            ]
        };
    }

}
